
import axios from 'axios';
export const GENERATE_PENDING_ACTION_REPORT_PDF_REQUEST = 'GENERATE_PENDING_ACTION_REPORT_PDF_REQUEST';
export const GENERATE_PENDING_ACTION_REPORT_PDF_SUCCESS = 'GENERATE_PENDING_ACTION_REPORT_PDF_SUCCESS';
export const GENERATE_PENDING_ACTION_REPORT_PDF_FAILURE = 'GENERATE_PENDING_ACTION_REPORT_PDF_FAILURE';
const { REACT_APP_API_URL } = process.env;

export const generatePendingActionReportPDFRequest = () => ({
  type: GENERATE_PENDING_ACTION_REPORT_PDF_REQUEST
});
export const generatePendingActionReportPDFSuccess = payload => ({
  type: GENERATE_PENDING_ACTION_REPORT_PDF_SUCCESS,
  payload
});
export const generatePendingActionReportPDFFailure = payload => ({
  type: GENERATE_PENDING_ACTION_REPORT_PDF_FAILURE,
  payload
});

export const pendingActionReportDataAction = payload => {
  return {
    type: 'PENDINGACTIONREPORTDATA',
    payload
  };
};

export const generatePendingActionReportPdfAPI = (payload, successCallback, errorCallback, headers = {}) => {
  return dispatch => {
    dispatch(generatePendingActionReportPDFRequest());
    axios
      .post(
        `${REACT_APP_API_URL}/get-pending-action-report`,
        payload,
        {
          responseType: 'blob',
          headers: headers,
        }
      )
      .then(response => {
        if (response.headers['content-type'] === 'application/pdf') {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl, '_blank');

          dispatch(generatePendingActionReportPDFSuccess());
        } else {
          errorCallback("Failed to generate PDF");
          dispatch(generatePendingActionReportPDFFailure());
        }
      })
      .catch(error => {
        console.error("Error downloading PDF:", error);
        errorCallback("Error occurred while downloading PDF");
        dispatch(generatePendingActionReportPDFFailure());
      });
  };
};

